module.exports = __webpack_public_path__ + "static/media/lobby.cc035ac0.webp";